import { Route } from 'react-router-dom'
import { TeamRedirectHandler } from 'screens/Organisation/components'
import { OrganisationScreenFeatureFlagWrapper } from 'screens/Organisation/OrganisationScreenFeatureFlagWrapper'
import {
  CarerSkillsScreen,
  DeviceAccessScreen,
  DeviceManageScreen,
  DeviceSignsScreen,
  OrganisationDocumentsScreen,
  ShiftPasswordsScreen,
  TeamScreen
} from 'screens/Organisation/screens'
import { TeamListGroupsRedirect } from 'screens/Organisation/screens/TeamList/TeamListGroupsRedirect'
import { TeamMemberEditScreenRedirect } from 'screens/Organisation/screens/TeamMemberEditScreen'
import { TeamMemberProfileScreenRedirect } from 'screens/Organisation/screens/TeamMemberProfileScreen'
import {
  ContractAndPreferencesScreen,
  EditContractAndPreferencesScreen
} from 'screens/Rostering/screens'
import AllAbsencesScreen from 'screens/Rostering/teamMembers/Absences/AllAbsences'
import EditIndividualAbsenceScreen from 'screens/Rostering/teamMembers/Absences/EditIndividualAbsence'
import IndividualAbsenceScreen from 'screens/Rostering/teamMembers/Absences/IndividualAbsence'
import { ID, PROFILE } from './utils'

const ORGANISATION_PATH = 'organisation'
const TEAM = 'team'
const LIST = 'list'
const SHIFT_PASSWORDS = 'shift-passwords'
const DOCUMENTS = 'documents'
const DEVICES = 'devices'
const ALL_ABSENCES = 'all-absences'
export const ORGANISATION = {
  INDEX: ORGANISATION_PATH,
  TEAM: `${ORGANISATION_PATH}/${TEAM}`,
  TEAM_PROFILE: `${ORGANISATION_PATH}/${TEAM}/${ID}/${PROFILE}`,
  TEAMS_LIST: `${ORGANISATION_PATH}/${TEAM}/${LIST}`
}

export const organizationRoutes = (
  <Route
    path={ORGANISATION_PATH}
    element={<OrganisationScreenFeatureFlagWrapper />}
  >
    <Route path={LIST} element={<TeamListGroupsRedirect />} />
    <Route path={TEAM} element={<TeamScreen />}>
      <Route index element={<TeamRedirectHandler />} />
      <Route
        path={`${ID}/${PROFILE}`}
        element={<TeamMemberProfileScreenRedirect />}
      />
      <Route
        path={`:id/${PROFILE}/edit`}
        element={<TeamMemberEditScreenRedirect />}
      />
      <Route path=":id/skills" element={<CarerSkillsScreen />} />
      <Route
        path=":id/contract-and-preferences"
        element={<ContractAndPreferencesScreen />}
      />
      <Route
        path=":id/contract-and-preferences/edit"
        element={<EditContractAndPreferencesScreen />}
      />
      <Route path=":id/absences" element={<AllAbsencesScreen />} />
      <Route
        path=":id/absences/:absenceId"
        element={<IndividualAbsenceScreen />}
      />
      <Route
        path=":id/absences/:absenceId/edit"
        element={<EditIndividualAbsenceScreen />}
      />
    </Route>
    <Route path={SHIFT_PASSWORDS} element={<ShiftPasswordsScreen />} />
    <Route path={DOCUMENTS} element={<OrganisationDocumentsScreen />} />
    <Route path={DEVICES} element={<DeviceAccessScreen />} />
    <Route path="devices/:id/manage" element={<DeviceManageScreen />} />
    <Route path="devices/signs" element={<DeviceSignsScreen />} />
    <Route path={ALL_ABSENCES} element={<AllAbsencesScreen all />} />
    <Route
      path={`${ALL_ABSENCES}/:absenceId`}
      element={<IndividualAbsenceScreen />}
    />
    <Route
      path={`${ALL_ABSENCES}/:absenceId/edit`}
      element={<EditIndividualAbsenceScreen />}
    />
  </Route>
)
